import { requireAuth } from '@/features/auth/guards/require-auth'
import { StorekeepingPage } from '@/features/storekeeping/pages/storekeeping-page'
import {
  storekeepingPendingQuery,
  storekeepingTodayQuery,
} from '@/features/storekeeping/queries/storekeeping-queries'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/storekeeping/` — admin-only storekeeper workbench.
 *
 *  - `beforeLoad`: chains `requireAuth` to populate `context.user`, then
 *    rejects non-staff users (Phase 12 storekeeping is admin-gated per
 *    AGENTS.md §17d). Non-admins get bounced to the root projects list,
 *    not to `/login`, because they ARE logged in — they just lack the
 *    permission. Matches the sidebar gating: the link only renders for
 *    admins, but URL-typers are also caught here.
 *  - `loader`: prefetches both queries in parallel so the page renders
 *    immediately on first paint (no Suspense flash).
 */
export const Route = createFileRoute('/_app/storekeeping/')({
  beforeLoad: async (params) => {
    const ctx = await requireAuth(params)
    if (!ctx.user.is_staff) {
      throw redirect({ to: '/projects/' })
    }
    return ctx
  },
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(storekeepingPendingQuery()),
      queryClient.ensureQueryData(storekeepingTodayQuery()),
    ]),
  staticData: { crumb: messages.nav.storekeeping },
  component: StorekeepingRoute,
})

function StorekeepingRoute() {
  return <StorekeepingPage />
}
